// extracted by mini-css-extract-plugin
export default {"content":"XXAqflxZtAptjlzgEKqT","focus-visible":"CHhVWGFGBWF4LO2ENXsg"};